/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAIEvaluationPathParams = NonNullable<operations['patchAIEvaluation']['parameters']['path']>;

export type PatchAIEvaluationRequestBody = OperationRequestBodyContent<operations['patchAIEvaluation']>;

export interface Input extends PatchAIEvaluationPathParams {
  apiVersion?: string;
  body: PatchAIEvaluationRequestBody;
  header: NonNullable<operations['patchAIEvaluation']['parameters']['header']>;
}

export async function patchAIEvaluation(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/internal/projects/{projectKey}/ai/evaluations/{evaluationId}', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
